import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import BannerHeader from "../../Component/Header/BannerHeader";
import Footer from "../../Component/Footer/Footer";
import Bannerimage from "../../assets/images/home/image.png";
import Own from "../../assets/images/home/own.png";
import Imagine from "../../assets/images/home/imagine.png";
import Distribute from "../../assets/images/home/distribute.png";
import TokenStats from "../../Component/Sections/TokenStats";
import "./home.css";

const pillars = [
  {
    number: "01",
    title: "Own",
    image: Own,
    description:
      "Choose a real-world location and mint a unique digital land collectible secured on Ethereum.",
  },
  {
    number: "02",
    title: "Imagine",
    image: Imagine,
    description:
      "Turn coordinates into a personal digital asset and shape how your place is represented online.",
  },
  {
    number: "03",
    title: "Distribute",
    image: Distribute,
    description:
      "Transfer, collect, and share digital land through a transparent ownership experience.",
  },
];

const Home = () => {
  const navigate = useNavigate();
  const { open } = useAppKit();
  const { isConnected } = useAppKitAccount();

  const handleWalletCta = async () => {
    if (isConnected) {
      navigate("/map");
      return;
    }

    try {
      await open({ view: "Connect" });
    } catch (error) {
      console.error("Unable to open wallet connection:", error);
    }
  };

  const handleExploreMap = async (event) => {
    if (isConnected) return;

    event.preventDefault();
    await handleWalletCta();
  };

  return (
    <div className="home-page">
      <BannerHeader />

      <main>
        <section className="home-hero">
          <img
            src={Bannerimage}
            alt=""
            aria-hidden="true"
            className="home-hero-scene"
          />
          <div className="home-shell home-hero-grid">
            <div className="home-hero-copy">
              <div className="home-eyebrow">
                <span aria-hidden="true" />
                DIGITAL LAND, ON CHAIN
              </div>
              <h1>Own a place in the digital world.</h1>
              <p>
                Discover locations on the map, mint digital land collectibles,
                and manage ownership through one simple experience.
              </p>
              <div className="home-hero-actions">
                <Link to="/map" className="home-primary-action" onClick={handleExploreMap}>
                  Explore the map
                  <span aria-hidden="true">↗</span>
                </Link>
                <a href="#how-it-works" className="home-secondary-action">
                  See how it works
                </a>
              </div>
              <div className="home-trust-row" aria-label="Platform highlights">
                <span>Ethereum secured</span>
                <span>Map-based discovery</span>
                <span>Transparent ownership</span>
              </div>
            </div>

          </div>
        </section>

        <TokenStats />

        <section className="home-intro" id="how-it-works">
          <div className="home-shell home-section-heading">
            <div>
              <span className="home-section-kicker">HOW SIMULE WORKS</span>
              <h2>From location to collectible.</h2>
            </div>
            <p>
              Simule connects geographic discovery with blockchain ownership,
              making digital land easy to explore, mint, and manage.
            </p>
          </div>

          <div className="home-shell home-pillar-grid">
            {pillars.map((pillar) => (
              <article className="home-pillar-card" key={pillar.title}>
                <div className="home-pillar-image">
                  <img src={pillar.image} alt={`${pillar.title} digital land`} />
                  <span>{pillar.number}</span>
                </div>
                <div className="home-pillar-content">
                  <h3>{pillar.title}</h3>
                  <p>{pillar.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="home-cta-section">
          <div className="home-shell">
            <div className="home-cta-card">
              <div>
                <span className="home-section-kicker">START EXPLORING</span>
                <h2>Your next digital land is on the map.</h2>
                <p>Connect your wallet and discover a location that matters to you.</p>
              </div>
              <button type="button" className="home-cta-button" onClick={handleWalletCta}>
                Connect wallet
                <span aria-hidden="true">↗</span>
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
